import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationHeader = () => {
  return (
    <div className="text-center space-y-4">
      {/* Brand */}
      <Link to="/product-catalog" className="inline-flex items-center">
        <span className="font-heading font-semibold text-2xl text-foreground" data-ocwp-field="brandName">
          Lalay Fashion
        </span>
      </Link>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-3xl font-heading font-semibold text-foreground">
          Join Lalay Fashion
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Discover premium fashion items, get personalized recommendations, and enjoy exclusive member benefits
        </p>
      </div>

      {/* Benefits */}
      <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
        <div className="flex items-center space-x-1">
          <Icon name="Gift" size={16} className="text-primary" />
          <span>Exclusive Offers</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Heart" size={16} className="text-primary" />
          <span>Wishlist & Favorites</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Truck" size={16} className="text-primary" />
          <span>Free Shipping</span>
        </div>
      </div>

      {/* Existing User Link */}
      <div className="flex items-center justify-center space-x-2 text-sm">
        <span className="text-muted-foreground">Already have an account?</span>
        <Link to="/user-login">
          <Button variant="link" className="p-0 h-auto text-primary hover:underline">
            Sign in here
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default RegistrationHeader;